import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;

export const postAssignUserToRoles = (data) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.ALL_ROLES.ASSIGN_USER_TO_ROLES,
    data,
    cancelToken
  );
};
